<template>
	<div id="svg-icon" :class="'is-txt-' + color" :style="{ width: width }">
		<svg
			width="100%"
			viewBox="0 0 226 423"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M105.25 0C144.86 0 153.06 37.63 153.08 51.45C153.08 64.62 150.51 66.63 150.6 79.98C150.66 90.12 153.6 97.22 153.33 102.98C151.77 132.98 111.21 141.63 99.63 141.8C88.05 141.97 37.63 132.21 37.63 108.89C37.63 92.62 47.98 66.6 47.7 48.53C47.08 11 78.46 0 105.25 0Z"
				fill="black"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M91 342H161.24L170.75 238.23L158.06 158.71L134.06 135.6L110 124.86L66.55 131.5L91 342Z"
				fill="#F7D167"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M78.9301 123.58C62.5101 124.03 13.4801 141.83 6.32005 159.89C0.880054 173.59 -2.84995 297.55 9.93005 303.6C10.7505 303.997 11.6079 304.311 12.4901 304.54C11.7201 308.34 4.36005 396.33 6.23005 403.65C8.10005 410.97 13.0101 422.05 20.1201 421.65C47.6301 420 98.1701 383.89 103.19 378C103.96 366.84 106.09 324.92 106.09 324.92L101.71 200.54L76.6401 132C76.6401 132 95.3501 123.13 78.9301 123.58Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M114.71 122.8C142.94 126.31 182.79 148.2 187.92 158.17C192.24 166.55 190.05 275.04 190.05 275.04C190.05 275.04 174.05 296.99 181.26 328.56C187.88 357.68 189.84 396.99 182.9 404.34C171.46 398.55 156.75 375.34 154.1 369.62C151.45 363.9 150.76 331.54 148.72 324.62C146.68 317.7 137.55 195.19 137.55 195.19C137.55 195.19 133.29 145.7 114.71 122.8Z"
				fill="white"
			/>
			<path
				d="M43.64 133.22C57.85 159.13 86.64 188.66 101.48 199.93"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M129 125.77C141.65 142.83 144.91 171.82 135 201.26"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M58 205.6C58 203.373 58.6607 201.195 59.8984 199.343C61.1361 197.491 62.8953 196.048 64.9533 195.196C67.0114 194.344 69.2759 194.122 71.4604 194.557C73.6449 194.992 75.6512 196.066 77.2256 197.642C78.7999 199.217 79.8716 201.225 80.3049 203.409C80.7382 205.594 80.5138 207.859 79.66 209.916C78.8063 211.973 77.3615 213.731 75.5085 214.967C73.6555 216.203 71.4775 216.862 69.25 216.86C66.2654 216.857 63.404 215.67 61.2945 213.558C59.185 211.447 58 208.585 58 205.6V205.6Z"
				stroke="#353823"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M63.48 205.6C63.48 204.463 63.8173 203.351 64.4491 202.405C65.0809 201.46 65.9789 200.723 67.0296 200.288C68.0803 199.852 69.2364 199.739 70.3518 199.96C71.4672 200.182 72.4918 200.73 73.2959 201.534C74.1001 202.338 74.6477 203.363 74.8696 204.478C75.0914 205.594 74.9776 206.75 74.5423 207.8C74.1071 208.851 73.3702 209.749 72.4246 210.381C71.479 211.013 70.3673 211.35 69.23 211.35C67.7051 211.35 66.2425 210.744 65.1642 209.666C64.0858 208.588 63.48 207.125 63.48 205.6Z"
				fill="#353823"
			/>
			<path
				d="M66.21 194.75C58.61 166.84 58.12 128 77.74 121"
				stroke="#353823"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M112 116.25C123.19 120.99 133.85 142.85 136.35 161.57"
				stroke="#353823"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M124.27 196.73C120.69 179.43 126.09 163.73 136.33 161.57C146.57 159.41 157.78 171.75 161.33 189.05C164.88 206.35 159.51 222.05 149.27 224.2C139.03 226.35 127.85 214 124.27 196.73Z"
				stroke="#353823"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M54.63 169.52L50.31 253.63"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M42.47 172L53.7 187.66"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M80 246.94L36.82 257.27L80 246.94Z"
				fill="#606060"
			/>
			<path
				d="M80 246.94L36.82 257.27"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M39 245.72L50 254.12"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M81.64 295.65C63.48 302.96 20.34 311.7 12.19 304.46C1.29003 294.77 -1.80997 194.76 3.66003 168.23C6.85003 152.79 22.96 142.85 31.36 138.85"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M68.66 299.93C63.48 293.36 61.5 260.6 64 250.77"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M69.23 257.17C69.2281 256.647 69.3812 256.136 69.6701 255.701C69.959 255.265 70.3706 254.925 70.8528 254.724C71.335 254.522 71.8661 254.469 72.3789 254.57C72.8917 254.67 73.363 254.921 73.7332 255.29C74.1034 255.659 74.3559 256.129 74.4585 256.641C74.5612 257.154 74.5095 257.685 74.31 258.168C74.1105 258.651 73.7721 259.064 73.3378 259.354C72.9034 259.645 72.3926 259.8 71.87 259.8C71.5238 259.801 71.1807 259.734 70.8605 259.603C70.5403 259.471 70.2491 259.278 70.0039 259.033C69.7586 258.789 69.564 258.499 69.4312 258.179C69.2984 257.859 69.23 257.516 69.23 257.17Z"
				fill="#C9C9C9"
			/>
			<path
				d="M64.42 337.47C58.678 339.687 52.5753 340.823 46.42 340.82C41.8529 340.776 37.3136 340.103 32.93 338.82C32.6007 340.088 32.4228 341.39 32.4 342.7V363.59C32.4 367.966 34.1384 372.163 37.2328 375.257C40.3271 378.352 44.524 380.09 48.9 380.09C53.2761 380.09 57.4729 378.352 60.5673 375.257C63.6616 372.163 65.4 367.966 65.4 363.59V342.68C65.3581 340.902 65.0271 339.142 64.42 337.47Z"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M128.42 190.52H214.65C219.88 190.52 223 194.61 221.65 199.65L188.36 322.11C187.548 324.685 185.958 326.945 183.809 328.58C181.661 330.215 179.058 331.144 176.36 331.24H90.18C84.96 331.24 81.83 327.15 83.18 322.11L116.46 199.65C117.269 197.081 118.852 194.824 120.993 193.19C123.134 191.555 125.728 190.623 128.42 190.52Z"
				fill="#6367FD"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M152.22 184.22H201.16C201.703 184.175 202.249 184.268 202.747 184.49C203.245 184.713 203.678 185.058 204.007 185.493C204.335 185.929 204.548 186.44 204.626 186.98C204.703 187.519 204.643 188.07 204.45 188.58L202.07 196.9C201.667 198.13 200.897 199.207 199.864 199.986C198.83 200.766 197.583 201.21 196.29 201.26H147.35C146.807 201.303 146.263 201.208 145.767 200.984C145.27 200.761 144.838 200.416 144.51 199.982C144.182 199.547 143.969 199.037 143.891 198.498C143.812 197.96 143.87 197.41 144.06 196.9L146.44 188.58C146.846 187.352 147.616 186.276 148.649 185.497C149.682 184.718 150.928 184.273 152.22 184.22Z"
				fill="#3B4161"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M79.75 252.94C83.5625 250.735 87.6114 248.967 91.82 247.67C97.89 242.67 102.35 222.92 103.96 221.67C105.57 220.42 110.96 221.23 111.12 223.1C111.82 229.95 111.45 237.95 105.38 245.1C123.04 233.87 124.38 228.89 129.24 232.65C134.1 236.41 135.85 254.75 131.68 262.33C120.2 283.25 90 286.08 80.76 286.22C78.46 276.27 78.46 264.24 79.75 252.94Z"
				fill="#F77F89"
			/>
			<path
				d="M132.35 238.09L116.9 250.46"
				stroke="#A7464F"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M134 250.89L114.38 266.49"
				stroke="#A7464F"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M220.16 250.3C219.92 246.18 221.16 237.03 224.82 228.3C226.16 225.14 226.24 219.94 221.53 219.94C216.17 219.94 209 230.7 212.53 243.51C216.06 256.32 220.51 256.12 220.16 250.3Z"
				fill="#F77F89"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M203.56 226.09C207.82 226.09 220.77 251.71 220.68 254.82C220.59 257.93 219.24 262.66 217.23 262.42C215.22 262.18 198.4 240.77 198.4 233.5C198.4 229.29 200.45 226.09 203.56 226.09Z"
				fill="#F77F89"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M198 240.81C203.31 240.81 217.31 261.23 217.41 263.57C217.51 265.91 214.68 268.06 212.34 268.16C210 268.26 193.27 254.54 193.27 248.16C193.24 244.26 195 240.81 198 240.81Z"
				fill="#F77F89"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M202.9 279C205.2 278.89 211.6 273.17 211.6 268.67C211.6 266.9 207.13 262.32 204.89 262.46C202.65 262.6 198.08 271.21 198.17 273.4C198.26 275.59 199.89 279.11 202.9 279Z"
				fill="#F77F89"
			/>
			<path
				d="M211.6 235.56C216.19 243.2 220.73 252.98 220.68 254.82"
				stroke="#A7464F"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M201.21 242.31C207.53 247.07 217.3 261.62 217.38 263.57"
				stroke="#A94B53"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M63.06 58.49C63.06 35.6 81.37 17 104 17C126.63 17 144.9 35.56 144.9 58.45C144.9 81.34 126.55 99.94 104 99.94C81.45 99.94 63.06 81.39 63.06 58.49Z"
				fill="#F77F89"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M97.9401 61.48C98.3801 58.84 99.94 56.89 101.5 57.15C103.06 57.41 103.92 59.75 103.5 62.39C103.08 65.03 101.5 66.98 99.9401 66.73C98.3801 66.48 97.5101 64.13 97.9401 61.48Z"
				fill="#B5545C"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M128.75 63.46C129.16 60.99 130.64 59.17 132.07 59.41C133.5 59.65 134.33 61.84 133.93 64.31C133.53 66.78 132.03 68.59 130.6 68.31C129.17 68.03 128.34 65.93 128.75 63.46Z"
				fill="#B5545C"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M69.31 76.74C71.74 83.5 77.85 118.63 76.31 131.39C82.71 141.09 111.23 138.39 119.73 130.18C115.5 118.37 115.34 109.9 116.89 99.94C118.36 90.62 66.88 70 69.31 76.74Z"
				fill="#F77F89"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M120.19 16C120.54 25.85 111.55 35.26 87.11 39.93C89.79 46.84 90.01 57.23 76.66 59.1C61.09 61.26 59.82 41.37 59.82 41.37L83.14 13.82C83.14 13.82 119.85 6.13001 120.19 16Z"
				fill="black"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M111.85 11.07C110.85 19.82 120.92 41.07 144.24 41.65C160.82 41.65 112.82 2.30999 111.85 11.07Z"
				fill="black"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M85.8001 98.47C83.5601 95.64 86.8001 82.74 90.3301 76.83C94.5901 74.32 109.7 76.41 117.49 69.71C119.78 67.71 121.01 69.19 122.79 71.38C125.92 75.22 135.33 77.21 138.85 79.38C139.37 84.98 134.23 97.8 132.01 100.67C128.53 105.22 96.7201 105.63 85.8001 98.47Z"
				fill="white"
			/>
			<path
				d="M92.39 78C90.33 74.56 81.33 59.17 78.46 55.27"
				stroke="white"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M87.57 97.65C81.48 97.65 67 78.6 65.35 72.21"
				stroke="white"
				stroke-width="3.41"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M56.06 61.89C56.06 59.2536 56.8418 56.6764 58.3065 54.4843C59.7713 52.2921 61.8531 50.5836 64.2889 49.5747C66.7246 48.5658 69.4048 48.3018 71.9906 48.8161C74.5763 49.3305 76.9515 50.6 78.8158 52.4643C80.68 54.3285 81.9496 56.7037 82.4639 59.2895C82.9782 61.8752 82.7143 64.5554 81.7053 66.9912C80.6964 69.4269 78.9879 71.5088 76.7958 72.9735C74.6037 74.4382 72.0265 75.22 69.39 75.22C65.8547 75.22 62.4642 73.8156 59.9643 71.3157C57.4644 68.8159 56.06 65.4253 56.06 61.89Z"
				fill="#F77F89"
			/>
			<path
				d="M104.69 351.64L151.39 350.18"
				stroke="#737999"
				stroke-width="1.7"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M32.49 419.2C17.49 425.48 6.23004 414.29 6.14004 403.2C6.05004 392.11 10.44 325.94 11.04 319.34"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M189.82 174C190.6 151.36 166.76 141 156.95 136.56"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M185.16 400C187.03 387.93 187.16 355.27 184 342.81"
				stroke="#C9C9C9"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";

	export default defineComponent({
		props: {
			color: String,
			width: String,
		},
	});
</script>

<style lang="stylus" scoped>
	#svg-icon {
		display: inline-block;
	}
</style>